// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: {
    hanzapp: {
      name: "@api-hanzapp",
      url:'https://hanzappsdev-anz.oc.holcim.net/dev/', //Microservice Dev
      // url: "http://localhost/dev/", //Microservice Local
      // url: '/api/',
      headers: {},
    },
  },
  base_url_bypass: {
    hanzappbypass: {
      name: "@api-hanzappbypass",
      // url:'/rest/', //Microservice Dev Bypass
       url:'https://hanzappsdev-anz.oc.holcim.net/',
      headers: {},
    },
  },
  HTTP_TIMEOUT: 180000,
  GOOGLE_OAUTH_CLIENTID:
    "695969267393-pbd07agdbnfb8a93psbomb1rbm9v4p7m.apps.googleusercontent.com",
  firebase: {
    apiKey: "AIzaSyCA2u3Vo0aEB_JDuo39pOkHVV9juCPg0co",
    authDomain: "hanz-epod-qa-316812.firebaseapp.com",
    projectId: "hanz-epod-qa-316812",
    storageBucket: "hanz-epod-qa-316812.appspot.com",
    messagingSenderId: "405452422844",
    appId: "1:405452422844:web:af7e75a7a3722591c2dab9",
    measurementId: "G-7J8XK6ZL0Y",
  },
  //Dev Details
  API_GATEWAY_KEY: "x-apigw-api-id",
  API_GATEWAY_ID: "1v5vhagxc8",

  //Pre-Prod Details
  // API_GATEWAY_KEY:"x-apigw-api-id",
  // API_GATEWAY_ID:"6xjowc0d7f"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
